export default {
  data() {
    return {
      dialogVisible: false,
      list: [],
      type: ''
    };
  },
  methods: {
    init(arr, type) {
      console.log(arr, type);
      this.list = arr;
      this.type = type;
      this.dialogVisible = true;
    }
  }
};